import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import * as React from 'react';
import MaskedInput from 'react-text-mask';
import { testAttr } from '../../helpers';
import Icon from '../Icon';
import useStyles from './Input.styles';
export const Input = ({ value = '', type = 'text', placeholder, readOnly, error = false, disabled = false, maxLength, max, min, multiline = false, multilineHeight, autoFocus = false, icon = null, mask, maskGuide = false, maskPlaceholderChar = '_', keepCharPositions = false, pipe, onChange = () => { }, onBlur, onFocus, onClick, testId, className, }, ref) => {
    const inputProps = Object.assign({ type: mask ? 'text' : type, disabled,
        value,
        placeholder,
        readOnly,
        maxLength,
        max,
        min,
        onBlur,
        onFocus,
        autoFocus,
        onClick }, testAttr(testId));
    const classes = useStyles();
    const inputClassName = cn(classes.input, icon && classes.inputWithIcon, error && classes.error, disabled && classes.disabled, className);
    const handleChange = React.useCallback((e) => {
        if (onChange) {
            onChange(e.target.value);
        }
    }, [onChange]);
    const renderInput = (refOrMaskedRef, maskedInputProps) => {
        let inputEl = null;
        if (multiline && !mask) {
            inputEl = (_jsx("textarea", Object.assign({ ref: refOrMaskedRef, className: inputClassName, onChange: handleChange, style: { height: multilineHeight } }, inputProps)));
        }
        else {
            inputEl = (_jsx("input", Object.assign({ className: inputClassName, ref: refOrMaskedRef }, inputProps, maskedInputProps)));
        }
        const iconEl = typeof icon === 'string' ? _jsx(Icon, { icon: icon }) : icon;
        return (_jsxs("div", Object.assign({ className: cn(classes.root, multiline && classes.multiline), style: { minHeight: multiline ? multilineHeight : 'none' } }, { children: [inputEl, iconEl && _jsx("div", Object.assign({ className: classes.icon }, { children: iconEl }))] })));
    };
    if (mask) {
        return (_jsx(MaskedInput, { placeholder: "", mask: mask, guide: maskGuide, placeholderChar: maskPlaceholderChar, pipe: pipe, keepCharPositions: keepCharPositions, onChange: handleChange, render: renderInput }));
    }
    return renderInput(ref, {
        onChange: (e) => onChange(e.target.value),
    });
};
// @ts-ignore
export default React.forwardRef(Input);
//# sourceMappingURL=Input.js.map